module.exports = __webpack_public_path__ + "static/media/Background.cdcde08c.md";